import { render, staticRenderFns } from "./ProjectSwitcher.vue?vue&type=template&id=3fcbd196&scoped=true"
import script from "./ProjectSwitcher.vue?vue&type=script&lang=js"
export * from "./ProjectSwitcher.vue?vue&type=script&lang=js"
import style0 from "./ProjectSwitcher.vue?vue&type=style&index=0&id=3fcbd196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcbd196",
  null
  
)

export default component.exports